export function isInViewport(el) {
  var rect = el.getBoundingClientRect();
  // return (
  //   rect.top >= 0 &&
  //   rect.left >= 0 &&
  //   rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
  //   rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  // );
  return (
    rect.bottom >= 0
    && rect.right >= 0
    && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    && rect.left <= (window.innerWidth || document.documentElement.clientWidth))
}